// extracted by mini-css-extract-plugin
export var apiV2ContractItem = "api-v2-contract-item_TeejTNlDUuxezV4zIKDg";
export var apiV2ContractItemDetails = "api-v2-contract-item__details_xPDmLRam8LVNOFKDWZHl";
export var apiV2ContractItemDetailsExpanded = "api-v2-contract-item__details_expanded_Jk4XfKC64adjwrcD9LzN";
export var apiV2ContractItemExpanded = "api-v2-contract-item_expanded_N5KnLt8Qo3XVBKQY6j5R";
export var apiV2ContractItemExpandedDetails = "api-v2-contract-item__expanded-details_nyLf4AgILq971ereTbBs";
export var apiV2ContractItemExpired = "api-v2-contract-item_expired_G7wagCm36RxuCXHta2Bp";
export var apiV2ContractItemHandle = "api-v2-contract-item__handle_SLG3oNvAtjExccIZ0ZGM";